export default "https://cdn-static.gokick.com/assets/dbba9902646848f8f0b834a64aaa98666d1f7693/images/citrus-zen.3d089e3f253b955a4e1c4ecfa30a73d4.png";